import styled from 'styled-components'
import { Text, Table as DefaultTable } from '@sketch/components'
import { ReactComponent as Apple } from '@sketch/icons/img-apple-17'
import { ReactComponent as Google } from '@sketch/icons/img-google-17'
import { ReactComponent as DotsIcon } from '@sketch/icons/dots-3-horizontal-17'
import { ReactComponent as MailIcon } from '@sketch/icons/img-mail-envelope-17'
import { ReactComponent as ArrowRaw } from '@sketch/icons/arrow-top-right-diagonal-16'

export const Table = styled(DefaultTable)`
  width: 100%;
` as typeof DefaultTable

export const MethodWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Provider = styled.span`
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`

export const MethodIdentifier = styled(Text.Span)`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const ActionCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
`

export const AppleIcon = styled(Apple)`
  width: 17px;
  height: 17px;
  /* Vertically align the Icon with the text */
  transform: translateY(-2px);
`

export const GoogleIcon = styled(Google)`
  width: 17px;
  height: 17px;
`

export const MailEnvelopeIcon = styled(MailIcon)`
  width: 17px;
  height: 17px;
  min-width: 17px;
  min-height: 17px;
  /* Vertically align the Icon with the text */
  transform: translateY(-1px);
`

export const Dots = styled(DotsIcon)`
  width: 24px;
  height: 24px;
`

export const Arrow = styled(ArrowRaw)`
  width: 17px;
  height: 17px;
  vertical-align: middle;
  /* Vertically align the Icon with the text */
  transform: translateY(-1px);
`
